import {
  GET_ADVERTISER,
  NEW_ADVERTISER,
  AUTHENTICATE
} from '../Actions/advertiserActions'

const initialState = {
  advertiser: {},
  advertisers: [],
  newAdvertiser: null
}
export default function advertiserReducer (state = initialState, action) {
  console.log(`action.type: ${action.type}`)
  switch (action.type) {
    case GET_ADVERTISER:
      return {
        ...state,
        advertiser: action.advertiser
      }
    case NEW_ADVERTISER:
      return {
        ...state,
        newAdvertiser: action.newAdvertiser
      }
    default:
      return {
        ...state,
        advertisers: 'WRONG'
      }
  }
}

// case UPDATE_ARTICLE:
//   return {
//     id: action.id,
//     title: action.payload.title,
//     content: action.payload.content,
